import React from 'react';
import PropTypes, { any } from 'prop-types';

import { drawPositionTypeIds } from '../../../utils/eventConstants';
import {
    getDoublesPlayerDisplayNameOfMatch,
    getSinglesPlayerDisplayNameOfMatch,
    shouldDisplayCheckedInMark,
} from '../../../utils/courtSchedular';

import styles from './courtSchedular.scss';

const MatchPlayerOrTeamDetails = (props) => {
    const {
        className,
        positionParam,
        match,
        playersDictByMemberId,
        teamsDict,
        'data-testid': dataTestId,
    } = props;

    const position = match[positionParam];
    const isV3 = !!match.participatingMembers;
    const participatingMembers = match.participatingMembers || [];

    const getCheckedIn = (pos, playerIdx) => {
        if (isV3) {
            return shouldDisplayCheckedInMark(pos, match, participatingMembers, playerIdx);
        }
        return shouldDisplayCheckedInMark(pos, match, playersDictByMemberId, teamsDict, playerIdx);
    };

    return (
        <div className={`${className} ${styles.playersData}`} data-testid={dataTestId}>
            {position?.typeId === drawPositionTypeIds.BYE && (
                'Bye'
            )}
            {position?.typeId === drawPositionTypeIds.PLAYER && (
                <>
                    <span className={styles.playerName}>
                        {isV3
                            ? getSinglesPlayerDisplayNameOfMatch(position, participatingMembers)
                            : getSinglesPlayerDisplayNameOfMatch(position, playersDictByMemberId)}
                    </span>
                    {getCheckedIn(position) && (
                        <span className={`utr-icon icon-check-mark-green ml4 ${styles.checkinMark}`} title="Player checked in" />
                    )}
                </>
            )}
            {position?.typeId === drawPositionTypeIds.TEAM && (
                <>
                    <span className={styles.playerName}>
                        {isV3
                            ? getDoublesPlayerDisplayNameOfMatch(position, participatingMembers, 0)
                            : getDoublesPlayerDisplayNameOfMatch(position, playersDictByMemberId, teamsDict, 0)}
                    </span>
                    {getCheckedIn(position, 0) && (
                        <span className={`utr-icon icon-check-mark-green ml4 ${styles.checkinMark}`} title="Player checked in" />
                    )}
                    <span> / </span>
                    <span className={styles.playerName}>
                        {isV3
                            ? getDoublesPlayerDisplayNameOfMatch(position, participatingMembers, 1)
                            : getDoublesPlayerDisplayNameOfMatch(position, playersDictByMemberId, teamsDict, 1)}
                    </span>
                    {getCheckedIn(position, 1) && (
                        <span className={`utr-icon icon-check-mark-green ml4 ${styles.checkinMark}`} title="Player checked in" />
                    )}
                </>
            )}
            {!position && (
                'TBD'
            )}
        </div>
    );
};

MatchPlayerOrTeamDetails.propTypes = {
    className: PropTypes.string,
    match: PropTypes.objectOf(any).isRequired,
    positionParam: PropTypes.string.isRequired,
    playersDictByMemberId: PropTypes.objectOf(any),
    teamsDict: PropTypes.objectOf(any),
    'data-testid': PropTypes.string,
};

MatchPlayerOrTeamDetails.defaultProps = {
    className: '',
    playersDictByMemberId: null,
    teamsDict: null,
    'data-testid': undefined,
};

export default MatchPlayerOrTeamDetails;
